/**
 * Project panel
 * UploadPicture.js
 * Created by stefensuhat on 2019-03-04 13:11
 */

import { makeStyles, Paper, Typography } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import ImageUploader from 'react-images-upload';

const propTypes = { setFieldValue: PropTypes.object };
const defaultProps = { setFieldValue: {} };

const styles = makeStyles(({ spacing, palette, typography }) => ({
    root: {
        marginBottom: spacing(2),
    },
    paper: {
        padding: spacing(2),
        border: `1px solid ${palette.divider}`,
    },
    uploaderLabel: {
        fontFamily: typography.fontFamily,
        letterSpacing: 0.5,
    },
    button: {
        background: `${palette.secondary.main} !important`,
        fontWeight: '600 !important',
    },
}));

function UploadField({ setFieldValue, photo, description }) {
    const classes = styles();

    return (
        <Paper elevation={0} className={classes.paper}>
            <Typography variant="h6">Picture</Typography>

            <Typography gutterBottom variant="body2">
                {description}
            </Typography>

            {!isEmpty(photo)
            && <img src={photo} width={150} alt={photo} />}

            <ImageUploader
                withIcon
                withPreview
                buttonText="Choose image"
                buttonClassName={classes.button}
                label="Max file size: 5MB. Supported files: .JPG | .PNG"
                labelClass={classes.uploaderLabel}
                onChange={(pictureFiles) => setFieldValue('image', pictureFiles[0])}
                imgExtension={['.jpg', '.png', '.svg']}
                maxFileSize={5242880}
                fileContainerStyle={{
                    boxShadow: 'none',
                    background: '#fff',
                }}
            />
        </Paper>
    );
}

UploadField.propTypes = propTypes;
UploadField.defaultProps = defaultProps;

export default UploadField;
